import routes, {getRoutes} from "./routes";
import {Route, Routes, Navigate, useNavigate} from "react-router-dom";
import Radium, { StyleRoot } from 'radium';
import {useEffect} from "react";
import session from "./utils/session";
import ToastHost from "./components/ToastHost";

function App() {
    const navigate = useNavigate();

  useEffect(() => {
      checkLoged() ;
  }, []);
    const checkLoged = async () => {
        const token = await session.getToken();
        if(!token) {
            navigate(`/login`);
        }
    }
  return (
      <StyleRoot>
          <div>
              <ToastHost />
              <Routes>
                {getRoutes(routes())}
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
          </div>
      </StyleRoot>
  );
}

export default Radium(App);
